import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner'

import classes from "./Tree.module.css"
import TreeNode from './TreeNode';


import {getOrganization, getOrgaTypes} from "../../api/OrganizationRequests"
import {getDevices, getMediaspots, AssociatedDevicesParameter} from "../../api/DevicesRequests"

import {
    findPathOfParentKey,
    getAllFlatedNodes,
    getAllStoreNodes,
    getChildKeys,
    getVarPath
} from "../../helpers/factories/FactoriesHelper"
import * as portalConfig from "../../portal_config.json"
import {NodeType} from "./NodeType"
//import DissociationModal from "../../admin/admin_areas/DissociationModal";
import {Trans} from "react-i18next";
import {getClientUUID} from "../../api/Auth"
import {getWebsocketServerLastContacts} from "../../api/MediaspotRequests"
import DissociationModal from './dissociationmodal/DissociationModal';


export default class Tree extends Component {


    state = {
        orgaTypeUUID: undefined,
        types: undefined,

        factories: undefined,
        factoriesLoading: true,

        loadingError: undefined,

        storeNodes:[],

        // When a new node is adding via form, this field contains parent node where new node will be added
        newNodeParentId: undefined,

        editingNodeId: undefined,


        allDevices: [],
        dissociationNode: undefined,
        dissociationDevicePath: undefined,
        dissociationInProgress: false,

        deviceToBlink: undefined

    }

    static getTypeFromString = (level, label) => {
        if(level === undefined || label === undefined){
            return undefined
        }

        if(label === level.nodeType){
            return level
        }
        if(level.child !== undefined){
            return this.getTypeFromString(level.child, label)
        }
        return undefined;
    }

    async componentDidMount() {
        try {
            // Start a refresh interval if not in area management mode
            this.initializeAutoRefresh();
    
            // Fetch initial data and set up the component state
            const [factoriesResponse, typesResponse] = await this.loadInitialData();
    
            // Handle potential errors from API responses
            if (factoriesResponse.error || typesResponse.error) {
                this.handleLoadingError(factoriesResponse.error || typesResponse.error);
                return;
            }
    
            // Initialize tree structure and set root node states
            const { currentNode, currentPath, currentNodeId } = this.setupTree(factoriesResponse);
    
            // Optionally auto-expand all areas
            this.autoExpandAreas(factoriesResponse);
    
            // Populate store nodes and finalize state
            const storeNodes = this.getAllStoreNodes(factoriesResponse);
            this.setState(
                {
                    orgaTypeUUID: typesResponse.orgTypeUUID,
                    types: typesResponse.org,
                    factories: factoriesResponse,
                    loadingError: undefined,
                    storeNodes: storeNodes
                },
                () => {
                    this.onNodeSelect(currentNode, currentNodeId, currentPath);
                    this.notifyFactoriesLoaded();
                }
            );
            console.log("state In Component Di")
            // Load additional data (e.g., mediaspots)
            await this.loadMediaspots();
        } catch (error) {
            console.error("Error in componentDidMount:", error);
            this.setState({ loadingError: 'Failed to load data' });
        }
    }
    
    initializeAutoRefresh() {
        if (this.props.isAreaManagement === undefined || this.props.isAreaManagement === false) {
            setInterval(this.reloadConfig, portalConfig.SUPERVISION_REFRESH_TICK_MILLISECONDS);
        }
    }
    
    async loadInitialData() {
        // Fetch both organization and org types concurrently
        const responses = await Promise.all([getOrganization()]);
        const factoriesResponse = responses[0];
        const orgTypeUUID = factoriesResponse[Object.keys(factoriesResponse)[0]]["orgTypeUUID"];
        const typesResponse = await getOrgaTypes(orgTypeUUID);
        return [factoriesResponse, typesResponse];
    }
    
    handleLoadingError(error) {
        this.setState({
            factoriesLoading: false,
            loadingError: error
        });
    }
    
    setupTree(factoriesResponse) {
        // Open the first node and set it as the current node
        const rootKey = Object.keys(factoriesResponse)[0];
        factoriesResponse[rootKey]["isOpen"] = true;
        let currentNode = factoriesResponse[rootKey];
        let currentPath = rootKey;
        let currentNodeId = rootKey;
    
        // If the root node is not allowed, search for the first allowed child node
        if (currentNode["isAllowed"] === false) {
            ({ currentNode, currentPath, currentNodeId } = this.findFirstAllowedNode(currentNode, currentPath));
        }
    
        return { currentNode, currentPath, currentNodeId };
    }
    
    findFirstAllowedNode(currentNode, currentPath) {
        let currentNodeId;
        while (currentNode && currentNode["isAllowed"] === false) {
            currentNodeId = getChildKeys(currentNode)[0];
            currentPath += "|" + currentNodeId;
            currentNode = currentNode[currentNodeId];
            if (currentNode) {
                currentNode["isOpen"] = true;
            }
        }
        return { currentNode, currentPath, currentNodeId };
    }
    
    autoExpandAreas(factoriesResponse) {
        if (this.props.autoExpandAllAreas === true) {
            this.openChilds(factoriesResponse[Object.keys(factoriesResponse)[0]]);
        }
    }
    
    getAllStoreNodes(factoriesResponse) {
        return getAllStoreNodes(factoriesResponse[Object.keys(factoriesResponse)[0]], Object.keys(factoriesResponse)[0]);
    }
    
    notifyFactoriesLoaded() {
        if (this.props.onFactoriesLoaded) {
            this.props.onFactoriesLoaded({ ...this.state.factories });
        }
    }
    

    componentDidUpdate(prevProps, prevState, snapshot) {
        // If new device to focus
        if(prevProps.focusedDevice !== this.props.focusedDevice && this.props.focusedDevice !== undefined){
           this.showDevice(this.props.focusedDevice.gsi1sk, this.props.focusedDevice.pk)
        }

        if(prevProps.focusedDevice !== undefined && this.props.focusedDevice === undefined){
            this.setState({deviceToBlink: undefined})
        }
    }

    addDeviceToParent = (devicesToAdd, deviceType, factories) => {
        // Loop over all modac from response
        for(let i = 0 ; i < devicesToAdd.length ; i++){
            let parentNode = undefined;
            // get path of node where modac is binded
            let nodePath = devicesToAdd[i].gsi1sk
            // get node object matching with modac node path
            let originalObject = getVarPath(factories, nodePath)

            // In case of in stock device, any device is associated, so they'll be added direcly in stock node
            if(devicesToAdd[i].status === "IN_STOCK"){
                parentNode = getVarPath(factories, nodePath)
            }else{
                // If parent device is not found is tree, continue
                if(devicesToAdd[i].parent_key === undefined){
                    continue;
                }
                const parentPath = findPathOfParentKey(originalObject, nodePath, devicesToAdd[i].parent_key.replace("|", "_@_"))
                if(parentPath === undefined){
                    continue
                }
                parentNode = getVarPath(factories, parentPath)
            }

            parentNode[devicesToAdd[i].pk.replace("|", "_@_")] = {
                type: deviceType,
                val: devicesToAdd[i].reference,
                id: devicesToAdd[i].pk,
                nodePath: devicesToAdd[i].gsi1sk,
                isArchiveDevice: devicesToAdd[i].status === "ARCHIVE",
                maxNbProbes: devicesToAdd[i].maxNbProbes
            }
        }
    }

    showDevice = (nodePath, deviceId) => {
        console.log("showDevice nodePath :",nodePath)
        console.log("showDevice deviceId :",deviceId)

        const pathComponents = nodePath.split("|")
        let currentPath = pathComponents[0]
        // Open all nodes of area path node by node
        for(let i = 1 ; i <= pathComponents.length ; i++){
            const node = getVarPath(this.state.factories, currentPath)
            node["isOpen"] = true
            currentPath += `|${pathComponents[i]}`
        }

        // Get final destination node (area)
        let originalObject = getVarPath(this.state.factories, nodePath)

        let deviceToFind = this.state.allDevices.find(device => device.pk === deviceId)

        if(deviceToFind === undefined || deviceToFind.parent_key === undefined){
            this.setState({deviceToBlink: deviceToFind})
            return
        }

        let deviceIdToFound = deviceToFind.parent_key.replace("|", "_@_")
        let parentPath = findPathOfParentKey(originalObject, nodePath, deviceIdToFound)

        let currentDevice = {...deviceToFind}
        while(parentPath !== undefined ){
            let object = getVarPath(this.state.factories, parentPath)
            object["isOpen"] = true

            currentDevice = this.state.allDevices.find(device => device.pk === object.id)
            if(currentDevice !== undefined && currentDevice.parent_key !== undefined){
                deviceIdToFound = currentDevice.parent_key.replace("|", "_@_")
                parentPath = findPathOfParentKey(originalObject, nodePath, deviceIdToFound)
            }else {
                parentPath = undefined
            }
        }
        this.setState({deviceToBlink: deviceToFind})
    }

    openChilds = (currentNode) => {
        const childKeys = getChildKeys(currentNode)
        childKeys.forEach(it => {
            if(currentNode[it].hasMediaspot !== true){
                currentNode[it]["isOpen"] = true
                this.openChilds(currentNode[it])

            }
        })
    }

    reloadConfig = async() => {
        console.log("reloadConfig")
        const response = await Promise.all([
            this.loadMediaspots(),
            // this.loadModacs()
        ]);
        this.forceUpdate()

        if(this.state.loadingError !== undefined && response[0] !== undefined && response[0].error === undefined && response[1].error === undefined){
            this.setState({loadingError: undefined})
        }
    }

    loadMediaspots = async() => {
        const responses = await Promise.all([
            getMediaspots(),
            // getWebsocketServerLastContacts()
        ])
        const mediaspotsResponse = responses[0]
        console.log("mediaspotsResponse",mediaspotsResponse)
        // const mediaspotsLastContactResponse = responses[1]
        if(mediaspotsResponse.error !== undefined){
            return {
                error: mediaspotsResponse.error
            }
        }

        for(let i = 0 ; i < mediaspotsResponse.length ; i++){
            let path = mediaspotsResponse[i].gsi1sk
            const originalObject = getVarPath(this.state.factories, path)

            if(originalObject["securispot"] !== undefined){
                Object.assign(originalObject["securispot"], mediaspotsResponse[i])
            }else if(originalObject !== ''){
                originalObject["securispot"] = mediaspotsResponse[i]
            }
            console.log("path:", path)
            console.log("original object:", originalObject)
        }
        
    }

    getChildNodes = (node) => {
        let nodes = getChildKeys(node).map(nodeKey => {
            return { id: nodeKey, node: node[nodeKey] };
        });
    
        // If nodes are not already created, they'll be added dynamically here
        console.log("this.props.isAreaManagement :", this.props.isAreaManagement)
        if (this.props.isAreaManagement === true) {
            if (node.securispot !== undefined) {
                nodes.push({
                    id: node.securispot.pk,
                    node: {
                        type: "securispot",
                        val: node.securispot.reference,
                    }
                });
            }
        }
    
        // Remove node of type 'store' if preventState
        if (this.props.isAreaManagement !== true) {
            nodes = nodes.filter(it => {
                if (it.node !== undefined) {
                    return it.node.isStore !== true;
                }
                return true;
            });
        }
    
        // Sorting logic
        nodes.sort((nodeA, nodeB) => {
            // Prioritize nodes of type MEDIASPOT
            if (nodeA.node.type === NodeType.MEDIASPOT && nodeB.node.type !== NodeType.MEDIASPOT) { return -1; }
            if (nodeB.node.type === NodeType.MEDIASPOT && nodeA.node.type !== NodeType.MEDIASPOT) { return 1; }
    
            // Handle isStore property
            if (nodeA.node.isStore === true && nodeB.node.isStore !== true) { return -1; }
            if (nodeB.node.isStore === true && nodeA.node.isStore !== true) { return 1; }
    
            // Sort by node.val if none of the above conditions apply
            return nodeA.node.val > nodeB.node.val ? 1 : -1;
        });
    
        console.log("nodes for ", node.val, "are : ", nodes);
        return nodes;
    }
    

    isGoodMediaspotConfigured = (node) => {
        if(node.detectedMediaspotSerial !== undefined && node.parent_key !== undefined && node.parent_key.includes("mediaspot-")){
            const extractedSerial = node.parent_key.replace("mediaspot-", "").split("|")[0]
            if(extractedSerial !== node.detectedMediaspotSerial){
                return false
            }
        }
        return true
    }

    onToggle = (node) => {
        if(node["isOpen"] === undefined){
            node["isOpen"] = true
        }else {
            node["isOpen"] = !node["isOpen"]
        }
    }

    onNodeSelect = (node, nodeId, nodePath) => {
        const { onSelect } = this.props;
        onSelect(node, nodeId, nodePath);
    }

    onNewNodeCreated = (id, name, levelType, path, isStore) => {
        const originalObject = getVarPath(this.state.factories, path)
        originalObject[id] = {
            hasMediaspot: false,
            isAllowed: true,
            isOpen: false,
            type: levelType.nodeType,
            val: name,
            isStore: isStore
        }

        this.setState({newNodeParentId: undefined})
    }

    onNodeAddingCancelled = () => {
        this.setState({newNodeParentId: undefined})
    }

    onNodeEditionCancelled = () => {
        this.setState({editingNodeId: undefined})
    }

    onDeleteNode = (nodeId, path) => {
        const parentPathComponents = path.split('|');
        if(parentPathComponents.length > 1){
            const toRemoved = parentPathComponents.pop()
            if(toRemoved === nodeId){
                const parentPath = parentPathComponents.reduce((it, val) => it + "|" + val)
                const originalObject = getVarPath(this.state.factories, parentPath)
                delete originalObject[nodeId]

                this.forceUpdate()
            }
        }
    }

    onDeleteDevice = (deviceId, path) =>{
        const parentPathComponents = path.split('|');
        if(parentPathComponents.length > 1){
            const toRemovedDeviceId = parentPathComponents.pop()
            if(toRemovedDeviceId === deviceId){
                const parentPath = parentPathComponents.reduce((it, val) => it + "|" + val)
                const originalObject = getVarPath(this.state.factories, parentPath)
                delete originalObject[deviceId]

                this.forceUpdate()
            }
        }
    }


    onNodeEdited = (path, label, type) => {
        const originalObject = getVarPath(this.state.factories, path)
        originalObject["val"] = label
        originalObject["type"] = type.nodeType

        this.setState({editingNodeId: undefined})
    }

    onDeviceDropped = (path, fullObject, nodeType, nodePath) => {
        try {
            // Validate fullObject is an object
            if (!fullObject || typeof fullObject !== 'object') {
                console.error("Invalid fullObject:", fullObject);
                return;
            }
    
            // Extract the original object based on the path
            const originalObject = getVarPath(this.state.factories, path);
    
            if (!originalObject) {
                console.error("Invalid path or object not found for path:", path);
                return;
            }
    
            // Ensure the original object is open
            originalObject["isOpen"] = true;
    
            // Handle nodeType-specific logic
            if (nodeType === NodeType.MEDIASPOT) {
                console.log(1)
                originalObject["hasMediaspot"] = true;
            }
    
            // Ensure fullObject.pk exists and is a string
            if (typeof fullObject.pk !== 'string') {
                console.error("Invalid fullObject.pk:", fullObject.pk);
                return;
            }
    
            // Replace "|" with "_@_" in the key
            const key = fullObject.pk.replace("|", "_@_");
    
            // Add or update the originalObject with the new device details
            originalObject[key] = {
                type: nodeType,
                val: fullObject.reference || 'Unknown', // Default to 'Unknown' if reference is missing
                id: fullObject.pk,
                nodePath: nodePath || 'Unknown', // Default to 'Unknown' if nodePath is missing
                maxNbProbes: fullObject.maxNbProbes || 0 // Default to 0 if maxNbProbes is missing
            };
            console.log("originalObject:", originalObject)

            // Extract storeNodePath and validate it
            const storeNodePath = fullObject.gsi1sk;
            if (storeNodePath) {
                const storeNodeOriginalObject = getVarPath(this.state.factories, storeNodePath);
                // If the store node original object exists, delete the key
                if (storeNodeOriginalObject !== undefined) {
                    delete storeNodeOriginalObject[key];
                }
            } else {
                console.warn("No storeNodePath found in fullObject.gsi1sk.");
            }
            // Force the component to re-render
            this.forceUpdate();
        } catch (error) {
            // Catch any unforeseen errors and log them
            console.error("Error in onDeviceDropped:", error);
        }
    }
    

    onDissociateRequest = (node, path) => {
        console.log("Tree onDissociateRequest called");
        this.setState(
            {
                dissociationInProgress: true,
                dissociationNode: node,
                dissociationDevicePath: path
            },
            () => {
                // This will be called after the state has been updated
                console.log("onDissociateClick Tree called with updated state:", this.state);
            }
        );
    };
    

    onDissociationModalClosed = () => {
        this.setState({dissociationInProgress: false, dissociationNode: undefined, dissociationDevicePath: undefined })
    }

    onDissociationSuccess = (storeNodeDestinationPath) => {
        console.log("onDissociationSuccess")
        console.log(this.state.allDevices)
        console.log(storeNodeDestinationPath)
        

        let nodePathComponents = this.state.dissociationDevicePath.split("|")
        const nodeIdToDelete = nodePathComponents.pop()
        let parentNodePath = nodePathComponents.reduce((it1, it2) => `${it1}|${it2}`)

        const originalObject = getVarPath(this.state.factories, parentNodePath)

        console.log(originalObject)


        // If deleted object is a mediaspot, parent node "hasMediaspot" attribute has to be reset to false
        const objectToDelete = getVarPath(this.state.factories, this.state.dissociationDevicePath)
        console.log(objectToDelete)

        if(objectToDelete.type === NodeType.MEDIASPOT){
            originalObject["hasMediaspot"] = false
        }

        // Make a copy of object to delete
        const copyOfDeletedObject = {...originalObject[nodeIdToDelete]}
        delete originalObject[nodeIdToDelete]

        // Get store node destination object
        const storeNodeDestination = getVarPath(this.state.factories, storeNodeDestinationPath)

        // Get all nodes and (sub-nodes) of deleted node to notify ids after path edition
        let flatNodes = getAllFlatedNodes(copyOfDeletedObject, true)

        // Get all keys child to keep other keys
        //storeNodeDestination[nodeIdToDelete] = copyOfDeletedObject
        flatNodes.forEach(node => {
            node.nodePath = storeNodeDestinationPath
            storeNodeDestination[node.id.replace("|", "_@_")] = node
        })
        getChildKeys(copyOfDeletedObject).forEach(keyToDelete => delete copyOfDeletedObject[keyToDelete])

        let originalNodeToDelete = {...copyOfDeletedObject}
        const keysToDelete = getChildKeys(originalNodeToDelete)
        keysToDelete.forEach(keyToDelete => {
            delete originalNodeToDelete[keyToDelete]
        })

        console.log(flatNodes)

        let devicesToDissociated = flatNodes.map(node => {
            console.log(node)
            return this.state.allDevices.find(it => node.id === it.pk && it.status !== "ARCHIVE")
        }).map(devices => {
            // After device dissociation, its original object has to be updated (status, path with store path and its deployment status)
            devices.gsi1sk = storeNodeDestinationPath
            devices.status = "IN_STOCK"
            devices.isDeployed = false
            return devices
        })

        this.props.onDevicesDissociated(devicesToDissociated)

        this.setState({dissociationInProgress: false, dissociationNode: undefined, dissociationDevicePath: undefined})
    }


    render() {
        if(this.state.factories === undefined && this.state.loadingError === undefined){
            return <div className={classes.TreeLoadingContainer}>
                <Loader type="Oval" color="#24A6E1" height={50} width={50}/>
            </div>
        }

        if(this.state.loadingError !== undefined){
            return <div>
                <label id={"tree_loading_error_label"}><Trans>AnErrorOccurredPleaseReload</Trans></label>
            </div>
        }
        console.log(this.state.factories)

        return Object.keys(this.state.factories).map(nodeKey => {
            return {
                id: nodeKey,
                val: this.state.factories[nodeKey]
            }
        }).map(node => {
            return (
                <div key={node.id}>
                    <TreeNode
                        key={node.id}
                        alreadySelectedNodeId={this.props.alreadySelectedNodeId}
                        onSelectModac={this.props.onSelectModac}
                        levelIndex={0}
                        levelType={NodeType.AREA}
                        node={node.val}
                        getChildNodes={this.getChildNodes}
                        onToggle={this.onToggle}
                        onNodeSelect={this.onNodeSelect}
                        nodeId={node.id}
                        path={node.id}
                        isAreaManagement={this.props.isAreaManagement}
                        enableEdition={this.props.enableEdition}
                        onAddClick={(parentNodeId) => { this.setState({newNodeParentId: parentNodeId})}}
                        onEditClick={(nodeId) => {this.setState({editingNodeId: nodeId})}}
                        newNodeAdding={this.state.newNodeParentId}
                        editingNodeId={this.state.editingNodeId}
                        isEditing={this.state.editingNodeId !== undefined && node.id === this.state.editingNodeId}

                        onNewNodeCreated={this.onNewNodeCreated}
                        onNodeAddingCancelled={this.onNodeAddingCancelled}
                        onNodeEdited={this.onNodeEdited}
                        onNodeEditionCancelled={this.onNodeEditionCancelled}
                        onNodeDeleted={this.onDeleteNode}

                        hideVisibleNodes={this.props.hideVisibleNodes}
                        hideStoreNodes={this.props.hideStoreNodes}
                        hideArchiveDevices={this.props.hideArchiveDevices}
                        types={this.state.types}

                        onMediaspotDropped={(path, fullObject, nodePath) => this.onDeviceDropped(path, fullObject, NodeType.MEDIASPOT, nodePath)}
                        onDissociateDevice={this.onDissociateRequest}
                        orgTypeUUID={this.state.orgaTypeUUID}

                        deviceToBlink={this.state.deviceToBlink}

                    />

                    {this.state.dissociationInProgress === true ? <DissociationModal onDissociationSuccess={this.onDissociationSuccess} dissociationNode={this.state.dissociationNode} storeNodes={this.state.storeNodes} onDismissModal={this.onDissociationModalClosed}/> : undefined}


                </div>
            )
        })
    }
}

Tree.propTypes = {
    onSelect: PropTypes.func.isRequired,
    onSelectModac: PropTypes.func.isRequired,
    alreadySelectedNodeId: PropTypes.any,
    maxLevel: PropTypes.any,

    onFactoriesLoaded: PropTypes.func,
    onModacFetched: PropTypes.func,

    isAreaManagement: PropTypes.bool,
    enableEdition: PropTypes.bool,

    hideVisibleNodes: PropTypes.bool,
    hideStoreNodes: PropTypes.bool,

    autoExpandAllAreas: PropTypes.bool,
    onDevicesDissociated: PropTypes.func,

    focusedDevice: PropTypes.any

};
